/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The LegalEntityRegionDTO model module.
 * @module model/LegalEntityRegionDTO
 * @version v0
 */
export class LegalEntityRegionDTO {
  /**
   * Constructs a new <code>LegalEntityRegionDTO</code>.
   * @alias module:model/LegalEntityRegionDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>LegalEntityRegionDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/LegalEntityRegionDTO} obj Optional instance to populate.
   * @return {module:model/LegalEntityRegionDTO} The populated <code>LegalEntityRegionDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new LegalEntityRegionDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('active'))
        obj.active = ApiClient.convertToType(data['active'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
LegalEntityRegionDTO.prototype.id = undefined;

/**
 * @member {String} name
 */
LegalEntityRegionDTO.prototype.name = undefined;

/**
 * @member {Boolean} active
 */
LegalEntityRegionDTO.prototype.active = undefined;

